<template>
  <div>
    <v-container>
      <v-card class="mx-auto my-5" max-width="2500">
        <v-system-bar class="py-5 px-3" color="#1973a5" style="color: #fff" dark>
          Lista de médicos</v-system-bar>
      </v-card>
      <v-card class="mx-auto my-5 elevation-1" max-width="2100">
        <v-row class="start ml-10" style="margin: 1rem 0">
          <v-col cols="6" sm="6" md="3" class="mx-3">
            <v-text-field max-width="200" class="mx-3" v-model="searchNombre" label="Nombre"
              prepend-inner-icon="mdi-magnify" variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="6" sm="6" md="3" class="mx-3">
            <v-text-field max-width="200" class="mx-3" v-model="searchDNI" label="DNI" prepend-inner-icon="mdi-magnify"
              variant="outlined" hide-details single-line></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-btn color="#1973a5" dark style="margin:1rem" @click="openCreate">
              Agregar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="mx-auto my-5" max-width="2500">
        <v-data-table :headers="header" :items="filteredData" class="elevation-1" :search="searchNombre">
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="openEdit(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="openDelete(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="#1973a5" dark>
          <v-card-text>
            Cargando Datos
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEdit" v-if="dialogEdit" max-width="500px">
        <FormMedico @closeEdit="closeEdit" :sendData="sendDataPadre" />
      </v-dialog>
      <v-dialog v-model="dialogDelete" v-if="dialogDelete" max-width="500px">
        <DeleteMedico @closeDelete="closeDelete" :sendData="sendDataPadre" />
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import FormMedico from "./form.vue";
import DeleteMedico from "./delete.vue";

export default {
  data() {
    return {
      sendDataPadre: {},
      dialogEdit: false,
      dialogDelete: false,
      dialogLoader: false,
      searchDNI: null,
      searchNombre: null,
      header: [
        { text: "Nombre", value: "nombre" },
        { text: "DNI", value: "dni" },
        { text: "Correo", value: "correo" },
        { text: "Teléfono", value: "telefono" },
        { text: "Acciones", value: "actions" }
      ],
      desserts: []
    }
  },
  methods: {
    openCreate() {
      this.dialogEdit = true;
    },
    closeCreate() {
      this.dialogEdit = false;
      this.sendDataPadre = {};
      this.listarMedico();
    },
    openEdit(item) {
      this.sendDataPadre = item;
      this.dialogEdit = true;
    },
    closeEdit() {
      this.dialogEdit = false;
      this.sendDataPadre = {};
      this.listarMedico();
    },
    openDelete(item) {
      this.sendDataPadre = item;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.sendDataPadre = {};
      this.dialogDelete = false;
      this.listarMedico();
    },
    listarMedico() {
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/generar_lista_medico/", {}, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              this.desserts = res.data;
            })
            .catch((res) => {
              this.dialogLoader = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    }
  },
  mounted() {
    if (!sessionStorage.getItem("keyValue")) {
      this.$router.push("/");
    }
  },
  computed: {
    filteredData() {
      if (!this.searchNombre && !this.searchDNI) {
        return this.desserts;
      }
      let filtered = this.desserts;
      if (this.searchNombre) {
        filtered = filtered.filter((item) =>
          item.nombre
            .toLowerCase()
            .includes(this.searchNombre.toLowerCase())
        );
      }
      if (this.searchDNI) {
        filtered = filtered.filter((item) =>
          item.dni
            .toLowerCase()
            .includes(this.searchDNI.toLowerCase())
        );
      }
      return filtered;
    },
  },
  created() {
    this.perfil = sessionStorage.getItem("perfil");
    this.nombre = sessionStorage.getItem("nombre");
    this.url = sessionStorage.getItem("url");
    this.usuario = sessionStorage.getItem("usuario");
    //INICIO DE CONSULTA
    this.listarMedico();
  },
  components: {
    FormMedico,
    DeleteMedico
  },
};
</script>
